exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".studens-list-title[data-v-d51ebacc]{color:rgba(0,0,0,.6);display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;align-items:center}.studens-list-title h4[data-v-d51ebacc]{margin-bottom:0;color:rgba(0,0,0,.6)}.studens-list-title span[data-v-d51ebacc]{margin-top:10px;font-size:14px}.wh-block__items[data-v-d51ebacc]{width:100%;margin-top:20px}.uk-input[data-v-d51ebacc]{margin-top:20px}.item-buttons[data-v-d51ebacc]{margin-top:10px}.item-buttons .header-menu__btn[data-v-d51ebacc]{font-size:12px}", ""]);

// exports
